import styles from 'src/styles/LeafSpinner.module.css';

/**
 * Branded loading indicator: a green arc spins around a gently breathing leaf.
 * Pure CSS/SVG (see LeafSpinner.module.css); respects prefers-reduced-motion.
 */
const LeafSpinner = () => <svg className={styles.spinner} viewBox="0 0 48 48" role="status" aria-label="Loading" data-sentry-element="svg" data-sentry-component="LeafSpinner" data-sentry-source-file="LeafSpinner.tsx">
    <g className={styles.arc} data-sentry-element="g" data-sentry-source-file="LeafSpinner.tsx">
      <circle className={styles.ring} cx="24" cy="24" r="18" data-sentry-element="circle" data-sentry-source-file="LeafSpinner.tsx" />
    </g>
    <path className={styles.leaf} d="M24 30 C18 26 16 20 24 13 C32 20 30 26 24 30 Z" data-sentry-element="path" data-sentry-source-file="LeafSpinner.tsx" />
  </svg>;
export default LeafSpinner;